import React from 'react'

import { Table } from '_zari/core'

const tableHeaderRows = [
  { label: 'COD' },
  { label: 'PROD' },
  { label: 'U MED' },
  { label: 'CANT' },
  { label: 'PRECIO' },
  { label: 'TOTAL' },
  { label: '' }
]

const ListaProductosAdicionalesSection = ({ detalles, dispatch }) => {
  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const tableRowTemplate = React.useCallback(
    row => (
      <Table.Row key={row._idFila}>
        <Table.Cell>{row.codigoProducto || '--'}</Table.Cell>
        <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
        <Table.Cell>{row.nombreUnidadDeMedida || '--'}</Table.Cell>
        <Table.Cell>{row.cantidad || '--'}</Table.Cell>
        <Table.Cell align='center'>{row.precio ? row.precio.toFixed(2) : '0.00'}</Table.Cell>
        <Table.Cell align='center'>{row.total ? row.total.toFixed(2) : '0.00'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={e => clickEliminar({ _idFila: row._idFila })}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEliminar]
  )

  return (
    <>
      <Table
        containerId='container-detallesnuevoasiento'
        filas={detalles}
        tablaDetalle
        headRows={tableHeaderRows}
        rowTemplate={tableRowTemplate}
      />
    </>
  )
}

export default React.memo(ListaProductosAdicionalesSection)
